module.exports = __webpack_public_path__ + "frontend-assets/img/leaderboard_icon-hover.462b47e0.png";